export default __webpack_public_path__ + "static/media/Thumbnail5.f255aca4.jpg";